import type {
  IDirectionData,
  IDirectionDataService,
  IMapPoint,
} from 'components/map/map-container/direction-data/types';
import type { IDirectionDataServiceParams } from './types';

export class Direction implements IDirectionDataService {
  constructor(private readonly params: IDirectionDataServiceParams) {}

  public get data(): IDirectionData {
    return {
      origin: this.origin,
      destination: this.destination,
      waypoints: this.waypoints,
    };
  }

  private get origin(): IMapPoint {
    return {
      lng: this.params.waypoints[0]?.lng ?? 0,
      lat: this.params.waypoints[0]?.lat ?? 0,
    };
  }

  private get destination(): IMapPoint {
    const lastWaypoint = this.params.waypoints[this.params.waypoints.length - 1];
    return {
      lng: lastWaypoint?.lng ?? 0,
      lat: lastWaypoint?.lat ?? 0,
    };
  }

  private get intermediateWaypoints() {
    return this.params.waypoints.slice(1, this.params.waypoints.length - 1);
  }

  private get waypoints() {
    return this.intermediateWaypoints.map((waypoint) => ({
      lng: waypoint?.lng ?? 0,
      lat: waypoint?.lat ?? 0,
    }));
  }
}
